import getClasses from "utils/getClasses";
import styles from "./StyledInput.module.scss";

export default function StyledInput({
  disableStyling = false,
  ...props
}: React.ComponentProps<"input"> & { disableStyling?: boolean }) {
  return (
    <input
      {...props}
      className={
        disableStyling
          ? props.className
          : getClasses(props.className, styles.input)
      }
    />
  );
}
